export default "__VITE_ASSET__CcVcJnRY__"